import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink,
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/entrenamiento";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllEntrenamientoByTax(params.tratamientoId);
}

export function EntrenamientoList(props) {
  const [entrenamientoList, setEntrenamiento] = useState([]);

  useEffect(() => {
    API.getAllEntrenamientoByTax(props.id)
      .then(setEntrenamiento)
      .catch(console.log);
  }, [props.id]);

  return (
    <>
      {entrenamientoList?.length ? (
        <ul className='entrenamiento cpt-list'>
          {entrenamientoList
            .sort((a, b) => {
              // Convertir las fechas a objetos de fecha para comparar
              const dateA = new Date(a.meta.metaFecha);
              const dateB = new Date(b.meta.metaFecha);
              // Ordenar de manera descendente (más reciente primero)
              return dateB - dateA;
            })
            .map((entrenamiento) => (
              <li key={entrenamiento.id}>
                <NavLink
                  to={`${props.id}/seguimiento/entrenamiento/${entrenamiento.id}`}
                >
                  {`Sesión ${entrenamiento.meta.entrNumses}`} -{" "}
                  {`${FormatDate(entrenamiento.meta.metaFecha)}`}
                </NavLink>
              </li>
            ))}
        </ul>

      ) : (
        <></>
      )}
    </>
  );
}

export function EntrenamientoListContent(props) {
  const [entrenamientoList, setEntrenamiento] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllEntrenamientoByTax(tratamientoId)
      .then(setEntrenamiento)
      .catch(console.log);
  }, [props.id]);

  return (
    <>
      <div id='content'>
        <h1>Entrenamiento</h1>
      </div>
      <div id='actions'>
      {(props.userRole.includes('administrador') || props.userRole.includes('entrenamiento')) && (
          <Link className='button is-link' to={`new`}>
            Nuevo
          </Link>
      )}
      </div>
    </>
  );
}
